export default __webpack_public_path__ + "static/media/ic_video.41d9c73a.svg";